module.exports = __webpack_public_path__ + "img/barcode.ec76ca61.png";